import { Scene } from 'phaser';

export class TweenAction {
  //@ts-ignore
  private scene: Scene;
  private targets: any;
  private delay = 0;
  private duration = 0;
  private ease = 'Linear';
  private repeat = 0;
  private yoyo = false;
  private depth: number | undefined;
  private offset: string | undefined;
  private onStart = () => {};
  private onComplete = () => {};
  private tweenConfig = {};

  constructor(scene: Scene, targets: any, duration: number) {
    this.scene = scene;
    this.targets = targets;
    this.duration = duration;
  }

  public run() {
    this.setTweenConfig();
    this.scene.tweens.add(this.tweenConfig);
  }

  public getTweenConfig() {
    this.setTweenConfig();
    return this.tweenConfig;
  }

  public setDelay(delay) {
    this.delay = delay;
    return this;
  }

  public setEase(ease) {
    this.ease = ease;
    return this;
  }

  public setRepeat(repeat) {
    this.repeat = repeat;
    return this;
  }

  public setYoyo(yoyo) {
    this.yoyo = yoyo;
    return this;
  }

  public setDepth(depth) {
    this.depth = depth;
    return this;
  }

  public setOffset(offset) {
    this.offset = offset;
    return this;
  }

  public setOnStart(onStart) {
    this.onStart = onStart;
    return this;
  }

  public setOnComplete(onComplete) {
    this.onComplete = onComplete;
    return this;
  }

  protected setTweenConfig() {
    this.setTweenConfigValue('targets', this.targets);
    this.setTweenConfigValue('delay', this.delay);
    this.setTweenConfigValue('duration', this.duration);
    this.setTweenConfigValue('ease', this.ease);
    this.setTweenConfigValue('repeat', this.repeat);
    this.setTweenConfigValue('yoyo', this.yoyo);
    this.setTweenConfigValue('onStart', this.onStart);
    this.setTweenConfigValue('onComplete', this.onComplete);

    if (this.depth) {
      this.setTweenConfigValue('depth', this.depth);
    }

    if (this.offset) {
      this.setTweenConfigValue('offset', this.offset);
    }
  }

  protected setTweenConfigValue(key, value) {
    this.tweenConfig[key] = value;
  }
}